export const addAssetErrorKey = {
    asset_nm: "자산명",
    asset_spec: "자산유형",
    asset_qty: "자산수량(숫자)",
    // os_type: "OS유형",
    asset_ip: "IP주소",
    ssh_port: "SSH Port",
    depart_nm: "담당팀",
    manager_nm: "담당자",
    supervisor_nm: "관리자",
    location_nm: "설치장소",
    service_nm: "용도(서비스)",
    use_yn: "사용여부(Y/N)",
    isms_yn: "ISMS대상(Y/N)",
    rms_yn: "취약점분석(Y/N)",
    confidential_score: "기밀성(점수)",
    integrity_score: "무결성(점수)",
    availability_score: "가용성(점수)",
    asset_grd: "보안등급(H/M/L)"
};

// 1. 규칙 객체 사용
export const commonRules = {
    req: { required: true, message: '필수 입력' },
    minlen: (min) => ({ min, message: `${min}글자 이상 입력 필요` }),
    maxlen: (max) => ({ max, message: `${max}글자 이하 입력 필요` }),
    reqstr: { pattern: /^[a-zA-Z0-9가-힣 _\-\(\)\/.#$&@!\?,]+$/, message: '특수문자 입력 불가' },
    reqhan: { pattern: /^[가-힣]+$/, message: '한글만 입력 가능' },
    reqip: { pattern: /^(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3}|\-)(?:[ ](?:[0-9]{1,3}\.){3}[0-9]{1,3})*$/, message: '정상 IP입력 필요' },
    reqct: { pattern: /^[1-9][0-9]*$/, message: '1이상 숫자 필요' },
    reqssh: { pattern: /^(?:[1-9][0-9]+|\-)$/, message: '2자리 이상 숫자 필요' },
    reqyn: { pattern: /^(Y|N)$/, message: 'Y 또는 N 입력 필요' },
    reqgrd: { pattern: /^(H|M|L)$/, message: 'H, M, L 중 하나 입력 필요' },
};

// 2. 규칙 생성 함수
export const ruleSimple = () => [
    commonRules.req,
];

export const ruleCommon = (min, max) => [
    commonRules.req,
    commonRules.minlen(min),
    commonRules.maxlen(max),
];

export const ruleIp = (max) => [
    commonRules.req,
    commonRules.reqip,
    commonRules.maxlen(max),
];

export const ruleAssetSpec = (min, max) => [
    commonRules.req,
    commonRules.minlen(min),
    commonRules.maxlen(max),
];

export const ruleAssetQty = (min, max) => [
    commonRules.req,
    commonRules.minlen(min),
    commonRules.maxlen(max),
    commonRules.reqct,
];

export const ruleString = (min, max) => [
    commonRules.req,
    commonRules.minlen(min),
    commonRules.maxlen(max),
    commonRules.reqstr,
];

export const ruleSshport = () => [
    commonRules.req,
    commonRules.reqssh,
];

// 3. 대상 집합들 적용 함수
export const fieldRules = {
    asset_nm: ruleCommon(1, 120),
    // os_type: ruleSimple(),
    asset_ip: ruleIp(65),
    ssh_port: ruleSshport(),    
    use_yn: [commonRules.reqyn],
    isms_yn: [commonRules.reqyn],
    rms_yn: [commonRules.reqyn],       
    asset_spec: ruleAssetSpec(2, 100),
    asset_qty: ruleAssetQty(1, 4),
    location_nm: ruleString(1, 100),
    depart_nm: ruleString(1, 100),
    manager_nm: ruleString(1, 100),
    supervisor_nm: ruleString(1, 100),
    service_nm: ruleString(1, 100),
};

export const fieldRulesTab = {
    asset_nm: ruleCommon(1, 120),
    asset_ip: ruleIp(65),
    ssh_port: ruleSshport(),
    asset_spec: ruleAssetSpec(2, 100),
    location_nm: ruleString(1, 100),
    manager_nm: ruleString(1, 100),
    supervisor_nm: ruleString(1, 100),
    service_nm: ruleString(1, 100),
};

export function validate(value, rules) {
    value = (value ===null ? value="": value);

    return rules.map(rule => {
        if (rule.required && !value) {
            return rule.message;
        }
        
        if (rule.min && value.length < rule.min) {
            return rule.message;
        }

        if (rule.max && value.length > rule.max) {
            return rule.message;
        }

        if (rule.pattern && !rule.pattern.test(value)) {
            return rule.message;
        }

        return null;
    }).filter(error => error !== null);
};


// const checkData = async(fieldRulesValue, item) => {

//     for (let key in fieldRulesValue) {
//         const errormsg =  await validate(item[key], fieldRulesValue[key]);
//         if (errormsg.length > 0) {
//             return [key, errormsg[0]];
//         }
//     }

//     return true;
// }